import { registerCommonPopup } from './commonPopupRegister'
import { registerBusinessPopup } from './businessPopupRegister'

export function register (app) {
  registerCommonPopup(app)
  registerBusinessPopup(app)
}
